export const tokenAddress = "0x26EbB8213fb8D66156F1Af8908d43f7e3e367C1d";
export const preSaleAddress = "0x602C90D796D746b97a36f075d9f3b2892B9B07c2";
export const usdtAddress = "0xF21DabbBe51C13F45EC1483F8fBF68C2CDdcA817";
export const usdcAddress = "0xF21DabbBe51C13F45EC1483F8fBF68C2CDdcA817";
/////////////////////mainnet///////////////////////////
// export const tokenAddress = "0x80A0ff3a055d2dB5B7341350C7f2d0343da6179a";
// export const preSaleAddress = "0x7E38b30f12020D79c5255B36F7461C35db9250cf";
// export const usdtAddress = "0x9fd2e8d73c8F6BeB0fDdA58e635775adaa6760Ed";
// export const usdcAddress = "0x9fd2e8d73c8F6BeB0fDdA58e635775adaa6760Ed";
